import { ReactNode } from 'react';

const ComingSoon = ({ children }: { children: ReactNode }) => {
  return (
    <section className="relative">
      {children}
      <div className="absolute inset-0 bg-slate-200 dark:bg-slate-700 dark:bg-opacity-70 bg-opacity-10 backdrop-blur-sm flex items-center justify-center rounded-md z-[1000] cursor-not-allowed">
        <span className="text-4xl text-transparent bg-gradient-to-r from-[#00F260] to-[#0575E6] bg-clip-text font-bold animate-bounce">
          Something cool is building up ...
        </span>
      </div>
    </section>
  );
};

export default ComingSoon;
